const ReviveOfferLogic = function (offer) {
    OfferLogic.call(this, offer);
};

ReviveOfferLogic.prototype = Object.create(OfferLogic.prototype);
ReviveOfferLogic.prototype.constructor = ReviveOfferLogic;

// the bracket picks the kit, an upgrade row replaces it where the store sells that product and the player qualifies,
// and the reward follows the kit (RewardsConfig.ReviveKits) - there is no second reward table to keep in step
ReviveOfferLogic.prototype.refresh = function () {
    OfferLogic.prototype.refresh.call(this);

    const upgrade = this.config.upgradeByPayerLevel && this.config.upgradeByPayerLevel[this.payerLevel];
    if (upgrade && connector.payments.getProduct(upgrade.product)
        && (!upgrade.available || cleverapps.user.checkAvailable(upgrade.available))) {
        this.product = upgrade.product;
    }

    this.reward = RewardsConfig.ReviveOfferReward(this.product);
};

// stashed into the purchase context at buy time and paid by a restore outside the level
ReviveOfferLogic.prototype.getRestoreRewards = function () {
    return RewardsConfig.ReviveRestoreReward(this.product);
};

// which step of the continue ladder the offer is bought on - 1 is the first continue
ReviveOfferLogic.GetStep = function () {
    const game = Game.currentGame;
    return game && game.prolongation ? game.prolongation.counter + 1 : 1;
};

ReviveOfferLogic.prototype.getPurchaseParams = function () {
    return { value: ReviveOfferLogic.GetStep() };
};

// the hard price of the continue the player is looking at - 900, 1900, ... - undefined once the ladder is exhausted
ReviveOfferLogic.GetContinuePrice = function () {
    const game = Game.currentGame;
    return game && game.prolongation ? game.prolongation.getOfferCurrencyPrice() : undefined;
};

// the offer sells the way out of this loss, so it appears when hard cannot buy it: a player who can pay
// the continue pays it, and showing the offer on every loss (17-27.09) only tripled opens for the same buys
ReviveOfferLogic.prototype.isAvailable = function () {
    // the bracket and the level can both change between two losses
    this.refresh();

    const price = ReviveOfferLogic.GetContinuePrice();
    return price === undefined || cleverapps.user.gold < price;
};

ReviveOfferLogic.getOffer = function () {
    if (Offers.TYPES.REVIVE_OFFER === undefined) {
        return undefined;
    }
    return cleverapps.offerManager.offers[Offers.TYPES.REVIVE_OFFER];
};

ReviveOfferLogic.isAvailable = function () {
    const offer = ReviveOfferLogic.getOffer();
    return Boolean(offer) && offer.logic.isAvailable();
};
